import React from "react";
import "./typography.css";

interface H3Props {
  text: string;
}
const H3: React.FC<H3Props> = ({ text }) => {
  return <h3 className="H3">{text}</h3>;
};

export default H3;
